<template>
    <div class="form-item-char15">
        <label class="label-caption">Situação</label>
        <select :value="opcaoSelecionada" @change="atualizarOpcao" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>


<script>
export default {
    props: {
        ckAddTodos: {type: Boolean, default: false},
        opcaoSelecionada: {type: Number, default: null}
    },

    computed: {
        lsTipos() {
            const tipos = [
                { id: 1, descricao: 'À CONFERIR' },
                { id: 2, descricao: 'INDEFERIDO' },
                { id: 5, descricao: 'CANCELADO' },
                { id: 9, descricao: 'HOMOLOGADO' }
            ];
            if (this.ckAddTodos) {
                tipos.unshift({ id: 0, descricao: 'TODOS' });
            }
            return tipos;
        }
    },

    methods: {
        atualizarOpcao(event) {
            this.$emit('update:opcaoSelecionada', Number(event.target.value));
        }
    }
};
</script>